import { Grid, TextField, Typography } from "@mui/material";
import React from "react";
import { useDocTransmittalContext } from "../DocTransmittal.context";

export default function DocTransmittalDataForm({ values, dataGrid, formName }) {
  const { newDoc, setNewDoc } = useDocTransmittalContext();

  const onChange = (e) => {
    const { name, value } = e.target;
    if (formName) {
      setNewDoc({
        ...newDoc,
        [formName]: { ...newDoc[formName], [name]: value },
      });
    } else {
      setNewDoc({ ...newDoc, [name]: value });
    }
  };
  return (
    <Grid container spacing={2} columns={{ xs: 6.8 }}>
      {dataGrid.map((item, index) => (
        <React.Fragment key={index}>
          <Grid item xs={item.grid}>
            <Typography>{item.label}:</Typography>
          </Grid>
          <Grid
            item
            xs={["number", "lifecycle"].includes(item.field) ? 2.3 : 2}
          >
            <TextField
              variant="outlined"
              value={values[item.field]}
              name={item.field}
              onChange={onChange}
              hiddenLabel
              size="small"
              disabled={[
                "Project Name",
                "Project Type",
                "Project Rev",
              ].includes(item.label)}
              fullWidth
              inputProps={{ sx: { padding: "2px", pl: "5px" } }}
            />
          </Grid>
        </React.Fragment>
      ))}
    </Grid>
  );
}
